<app-login-container>
	<div class="margin-container">
		<h2
			class="row-center title-margin title-font-size text-main-color"
			style="font-size: 30px"
			data-automation-id="loginAuthentication-signIn"
			i18n="Sign in | sign into the website@@loginAuthentication-signIn"
		>
			Sign in
		</h2>

		<form [formGroup]="formGroup">
			<mat-form-field
				appearance="outline"
				label="Email"
				i18n-label="@@loginAuthentication-emailHeader"
				subscriptSizing="dynamic"
			>
				<mat-label i18n="for email input@@loginAuthentication-emailLabel">Email</mat-label>
				<input type="email" matInput formControlName="email" required data-automation-id="email-input" />
				@if (showError('email') && !this.formGroup.get('email')?.hasError('required')) {
					<mat-error
						class="row-left"
						i18n="Please enter a valid email address | invalid email on login @@loginAuthentication-invalidEmail"
						data-automation-id="email-error"
					>
						Please enter a valid email address.
					</mat-error>
				}
			</mat-form-field>

			<mat-form-field
				appearance="outline"
				label="Password"
				i18n-label="@@loginAuthentication-passwordLabel"
				style="margin-bottom: 6px"
				subscriptSizing="dynamic"
			>
				<mat-label i18n="Label for password input @@loginAuthentication-password">Password</mat-label>
				<input
					type="password"
					matInput
					formControlName="password"
					autocomplete="off"
					required
					data-automation-id="password-input"
				/>
			</mat-form-field>

			<a
				class="row-left cursor-pointer forgot-password"
				(click)="navigateToForgotPassword()"
				i18n="Forgot password link @@loginAuthentication-forgotPassword"
				data-automation-id="forgot-password-link"
				>Forgot password?</a
			>
			<div class="login-session-checkbox">
				<mat-checkbox
					color="primary"
					class="checkbox-padding-right"
					[checked]="allDayCheckbox"
					(change)="updateAllDayCheckbox()"
					data-automation-id="all-day-checkbox"
				></mat-checkbox>
				<div>
					<p class="font-12">
						<span class="font-12 subtext-color" i18n="@@loginAuthentication-keepMeSignedIn"
							>Keep me signed in for today.</span
						>&nbsp;
						<span class="font-12 subtext-secondary-color" i18n="@@loginAuthentication-keepMeSignedInDontCheckBox">
							Don't check this box if you're at a public or shared computer.
						</span>
					</p>
				</div>
			</div>
		</form>

		<div class="row-center">
			<app-loading-indicator diameter="35" [style]="{ height: '65px' }">
				<button
					mat-flat-button
					type="submit"
					(click)="onLoginClick()"
					class="primary-button"
					i18n="Login button @@loginAuthentication-login"
					data-automation-id="login-auth-button"
				>
					Login
				</button>
			</app-loading-indicator>
		</div>

		<div class="row-center margin-bottom-24">
			<ng-container class="language-dropdown">
				<mat-icon class="language-icon">language</mat-icon>
				<button mat-button [matMenuTriggerFor]="menu" data-automation-id="login-auth-language-menu-button">
					<span class="language-button">
						<span>{{ siteLanguage }}</span>
						<mat-icon class="language-arrow">arrow_drop_down</mat-icon>
					</span>
				</button>
				<mat-menu #menu="matMenu">
					@for (lang of languageList; track lang) {
						<a
							mat-menu-item
							class="language-dropdown-item"
							href="/{{ lang.code }}"
							[attr.data-automation-id]="'language-option-' + lang.label"
							>{{ lang.label }}</a
						>
					}
				</mat-menu>
			</ng-container>
		</div>
	</div>
</app-login-container>
